/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Form_Clients_SelectedInputs */

const en_users_form_clients_selected = /** @type {(inputs: Users_Form_Clients_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selected`)
};

const pt_br2_users_form_clients_selected = /** @type {(inputs: Users_Form_Clients_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecionado`)
};

/**
* | output |
* | --- |
* | "Selected" |
*
* @param {Users_Form_Clients_SelectedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_form_clients_selected = /** @type {((inputs?: Users_Form_Clients_SelectedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Form_Clients_SelectedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_form_clients_selected(inputs)
	return pt_br2_users_form_clients_selected(inputs)
});